import React, { Component } from 'react';
import Firebase from 'firebase';
import 'firebase/functions';
import Moment from 'moment';
import * as ROUTES from '../../constants/routes';
import Connector from '../../data/Connector';
import HelperBusiness from '../../helper/Business';
import { Link, withRouter } from 'react-router-dom';
import EventEmitter from '../../helper/Emitter';
import Navigation from '../../components/Navigation';
import ListEmpty from '../../components/List/empty';
import FormCard from '../../components/Form/card';
import Loader from '../../components/Form/loader';
import HelperEmptyImg from '../../helper/EmptyLarge';
import HelperBilling from '../../helper/Billing';
import WidgetCard from '../../components/Widgets/card';
import ModalMessageSimple from '../../components/Modals/message-simple';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class PayInvoicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      clients: global.clients,
      products: [],
      product: null,
      client: null,
      type: 'sessions',
      log: global.userLog,
      loading: false,
      card: false,
      valuesCard: ['', '', '', '', ''],
      errorCard: [false, false, false, false, false],
      trial: 'notset',
      search: '',
      back: '/admin',
      method: 'card',
      token: '',
      notes: '',
      invoice: '',
      item: null,
      date: Moment().format('X'),
      dateChange: false,
      showOverlay: false,
      hidden: 'hidden',
      margin: 0,
      showModalStock: false,
    };
  }


  componentDidMount() {
    var arr = this.props.location.pathname.split('/')
    var id = arr[arr.length-3]
    if(id !== 'admin' && id !== 'pay-invoice') {
      global.uid = id
    }
    var prod = arr[arr.length-1]

    Connector.setUser()
    document.title = +'Pay an invoice - '+global.userBusiness
    window.scrollTo(0, 0)
    
    this.setState({
      done: true,
      invoice: prod,
    })

    this._isMounted = true

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('clientsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('invoicesLoaded', (event) => this.configureData())
    EventEmitter.subscribe('paymentsLoaded', (event) => {
      this.configureData()
      if(this.state.loading) {
        global.message = lang.t('messaging:message.paymentsuccessful')
        setTimeout(() => {
          EventEmitter.dispatch('updateBadges', 'payment');
        }, 1000);
        if(this.state.loading) {
          this.topUpClient()
        }
      }
    })
    EventEmitter.subscribe('userLoaded', (event) => this.checkSpace())
    EventEmitter.subscribe('clientLoaded', (event) => this.configureData())
    EventEmitter.subscribe('logLoaded', (event) => this.configureLog())
    EventEmitter.subscribe('productsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('invoicesLoaded', (event) => this.configureData())
    this.configureData()
  }


  componentWillUnmount() {
    this._isMounted = false
    this.setState({
      loading: false
    })
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('clientLoaded', () => {})
    EventEmitter.unsubscribe('logLoaded', () => {})
    EventEmitter.unsubscribe('productsLoaded', () => {})
    EventEmitter.unsubscribe('invoicesLoaded', () => {})
  }


  checkSpace() {
    if(global.uid === '') {
      this.props.history.push(ROUTES.LOADING)
    } else {
      var found = false
      for(var item of global.userStaff) {
        if(item.id === global.uid) {
          found = true
        }
      }
      if(found) {
        document.title = lang.t('header:title.payment')+' - '+global.userBusiness
        this.configureData()
      } else {
        this.props.history.push(ROUTES.LOADING)
      }
    }
  }


  configureData() {
    if(this._isMounted) {
      var arr = this.props.location.pathname.split('/')
      var id = ''
      var item = null
      var product = null
      var invoice = ''
      var products = []
      var back = 'admin'
      var card = false

      for(var inv of global.invoices) {
        if(inv.id === arr[arr.length-1]) {
          invoice = inv.id
          id = inv.data.client
          item = inv
        }
      }

      back = global.currentPage
      if(global.linkCli !== '') {
        back = global.linkCli
      }

      var selected = null
      if(id !== '') {
        for(var client of global.clients) {
          if(client.id === id) {
            selected = client
          }
        }
      }

      // Invoice products
      if(item !== null) {
        var ar = item.data.product.split(',')
        for(var a of ar) {
          for(var prod of global.products) {
            if(prod.id === a) {
              product = prod
              products.push(prod)
            }
          }
        }
      }

      var card = true
      if(global.userCard !== '') {
        card = false
      }
      
      this.setState({
        clients: global.clients,
        product: product,
        products: products,
        client: selected,
        invoice: invoice,
        item: item,
        back: back,
        card: card
      })
    }
  }


  configureLog() {
    this.setState({
      log: global.userLog
    }, () => {
      if(this.state.loading) {
        for(var item of this.state.log) {
          if(item.data.title === 'chargeerror') {
            EventEmitter.dispatch('showMessageError', item.data.message);
            Firebase.database().ref('/log/'+global.uid+'/'+item.id).remove()
            this.setState({
              loading: false,
            })
          }
          if(item.data.title === 'charge' || item.data.type === 'charge') {
            Connector.sendPushNotification(global.clientToken, "Payment made", global.userName+" just paid Invoice "+this.state.item.data.number+" ("+global.curSym+this.state.item.data.price.toFixed(2)+").", 'payment', 'payment')
            EventEmitter.dispatch('showMessage', lang.t('message:payment'));
            if(this.state.loading) {
              this.topUpClient()
            }
          }
        }
      }
    })
  }



  // Interactive ------------------------------------------------------------



  setDate(date) {
    this.setState({
      date: date,
      dateChange: true
    })
  }


  checkMakePayment() {
    this.setState({errorCard: [false, false, false, false, false]})
    var tmp = [false, false, false, false, false]
    var passed = true
    var desc = ''
    if(this.state.valuesCard[0] === '') {
      tmp[0] = true
      passed = false
    }
    if(this.state.valuesCard[1] === '') {
      tmp[1] = true
      passed = false;
    }
    if(this.state.valuesCard[2] === '') {
      tmp[2] = true
      passed = false;
    }
    if(this.state.valuesCard[3] === '') {
      tmp[3] = true
      passed = false;
    }
    if(this.state.valuesCard[4] === '') {
      tmp[4] = true
      passed = false;
    }
    this.setState({errorCard: tmp})

    var passed2 = true
    var stock = -1
    for(var product of this.state.products) {
      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock === 0) {
          passed2 = false
        }
      }
      if(product.data.desc !== '' && product.data.desc !== undefined) {
        desc += product.data.desc+'\n'
      }
    }
    
    if(!passed2) {
      this.setState({
        showModalStock: true
      })
    }

    if(passed && passed2) {
      // Execute payment
      this.setState({
        loading: true,
      })
      var fee = this.state.item.data.price*0.5
      var email = global.userEmail

      if(this.state.client.data.cardId !== '' && this.state.client.data.cardId !== undefined) {
        var callFunction3 = Firebase.functions().httpsCallable('connectedManageClientCardV2');
        callFunction3({type: 'delete', account: global.userStripeConnect, customer: this.state.client.data.customer, card: this.state.client.data.cardId}).then(function(result) {});
      }

      if(this.state.client.data.customer !== '' && this.state.client.data.customer !== undefined) {
        var callFunction = Firebase.functions().httpsCallable('connectedPaymentV2');
        callFunction({type: 'card', account: global.userStripeConnect, clientname: global.userName, amount: parseInt(this.state.item.data.price*100), fee: fee, pack: 'Invoice: '+this.state.item.data.number, email: email, name: this.state.valuesCard[0], card: this.state.valuesCard[1], month: this.state.valuesCard[2], year: this.state.valuesCard[3], cvc: this.state.valuesCard[4], customer: global.userStripe, client: global.spaceClient, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, desc: desc, payer: global.uidUser}).then(function(result) {});
      } else {
        var callFunction2 = Firebase.functions().httpsCallable('connectedPaymentV2');
        callFunction2({type: 'account', account: global.userStripeConnect, amount: parseInt(this.state.item.data.price*100), fee: fee, pack: 'Invoice: '+this.state.item.data.number, email: email, name: this.state.valuesCard[0], card: this.state.valuesCard[1], month: this.state.valuesCard[2], year: this.state.valuesCard[3], cvc: this.state.valuesCard[4], clientname: global.userName, client: global.spaceClient, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, desc: desc, payer: global.uidUser}).then(function(result) {});
      }
    }
  }


  makePayment() {
    this.hideOverlayConfirm()
    var passed = true
    var desc = ''
    for(var product of this.state.products) {
      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock === 0) {
          passed = false
        }
      }
      if(product.data.desc !== '' && product.data.desc !== undefined) {
        desc += product.data.desc+'\n'
      }
    }
    if(!passed) {
      this.setState({
        showModalStock: true
      })
    }

    if(passed) {
      global.badgeLocked = true
      this.hideModals()
      this.setState({
        loading: true,
      })
      var email = global.userEmail

      var fee = this.state.item.data.price*0.5 //includes *100 calculation
      var callFunction = Firebase.functions().httpsCallable('connectedPaymentV2');
      callFunction({type: 'pay', account: global.userStripeConnect, amount: parseInt(this.state.item.data.price*100), fee: fee, customer: global.userStripe, client: global.spaceClient, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, email: email, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, pack: 'Invoice: '+this.state.item.data.number, stock: -1, desc: desc, payer: global.uidUser}).then(function(result) {
        //var sanitizedMessage = result.data.text;
      });
    }
  }


  topUpClient() {
    this.setState({
      loading: false
    })

    var hasCreditGS = false
    var hasCredit11 = false

    var combinedGS = 0
    var combined11 = 0
    var account = ''
    if(this.state.item.data.account !== undefined) {
      account = this.state.item.data.account
    }

    var cgs = {id: '', paid: 0}
    var c11 = {id: '', paid: 0}

    for(var product of this.state.products) {
      var sessions11 = product.data.sessions11
      if(product.data.stype === '11') {
        sessions11 = product.data.sessions
      }

      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock !== 0) {
          Firebase.database().ref('/packs/'+global.uid+'/'+product.id).update({
            stock: product.data.stock-1
          })
        }
      }

      var expdate = parseInt(Moment().add(product.data.expires, product.data.expType).format('X'))
      if(this.state.dateChange) {
        expdate = parseInt(Moment(this.state.date, 'X').add(product.data.expires, product.data.expType).format('X'))
      }

      if(product.data.type !== 'other') {
        if(product.data.expires !== undefined) {
          var totalGS = 0
          var total11 = 0
          var num = 0
          for(var cred1 of global.credits) {
            if(cred1.data.group && (product.data.stype === 'both' || product.data.stype === 'group') && cred1.data.sessionsTotal > cred1.data.sessionsPaid && cred1.data.expires === undefined) {
              if(cred1.data.account === account || (cred1.data.account === undefined && account === '')) {
                totalGS = cred1.data.sessionsTotal-cred1.data.sessionsPaid-combinedGS
                if(totalGS > product.data.sessions) {
                  totalGS = product.data.sessions
                }
                if(totalGS < 0) {
                  totalGS = 0
                }
                combinedGS += totalGS
                num = cred1.data.sessionsPaid+combinedGS
                cgs.id = cred1.id
                cgs.paid = num
              }
            }
            if(!cred1.data.group && (product.data.stype === 'both' || product.data.stype === '11') && cred1.data.sessionsTotal > cred1.data.sessionsPaid && cred1.data.expires === undefined) {
              if(cred1.data.account === account || (cred1.data.account === undefined && account === '')) {
                total11 = cred1.data.sessionsTotal-cred1.data.sessionsPaid-combined11
                if(total11 > sessions11) {
                  total11 = sessions11
                }
                if(total11 < 0) {
                  total11 = 0
                }
                combined11 += total11
                num = cred1.data.sessionsPaid+combined11
                c11.id = cred1.id
                c11.paid = num
              }
            }
          }

          if(product.data.stype === 'both' || product.data.stype === 'group') {
            Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits').push({
              sessionsTotal: totalGS,
              group: true,
              sessionsPaid: product.data.sessions,
              type: 'sessions',
              client: global.spaceClient,
              account: account,
              expires: expdate,
              product: product.id,
              name: product.data.name
            })
          }
          if(product.data.stype === 'both' || product.data.stype === '11') {
            Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits').push({
              sessionsTotal: total11,
              group: false,
              sessionsPaid: sessions11,
              type: 'sessions',
              client: global.spaceClient,
              account: account,
              expires: expdate,
              product: product.id,
              name: product.data.name
            })
          }
          
        } else {
          // Check for existing credits
          for(var cred of global.credits) {
            if(cred.data.group && (product.data.stype === 'both' || product.data.stype === 'group')) {
              if(cred.data.account === account || (cred.data.account === undefined && account === '')) {
                hasCreditGS = true
                var num1 = cred.data.sessionsPaid+product.data.sessions
                Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits/'+cred.id).update({
                  sessionsPaid: num1
                })
              }
            }
            if(!cred.data.group && (product.data.stype === 'both' || product.data.stype === '11')) {
              if(cred.data.account === account || (cred.data.account === undefined && account === '')) {
                hasCredit11 = true
                var num2 = cred.data.sessionsPaid+sessions11
                Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits/'+cred.id).update({
                  sessionsPaid: num2
                })
              }
            }
          }

          // Create new credit entries
          if(!hasCreditGS && (product.data.stype === 'both' || product.data.stype === 'group')) {
            Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits').push({
              sessionsTotal: 0,
              group: true,
              sessionsPaid: product.data.sessions,
              type: 'sessions',
              client: global.spaceClient,
              account: account
            })
          }
          if(!hasCredit11 && (product.data.stype === 'both' || product.data.stype === '11')) {
            Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits').push({
              sessionsTotal: 0,
              group: false,
              sessionsPaid: sessions11,
              type: 'sessions',
              client: global.spaceClient,
              account: account
            })
          }
        }
      }
    }

    if(cgs.id !== '') {
      Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits/'+cgs.id).update({
        sessionsPaid: cgs.paid
      })
    }
    if(c11.id !== '') {
      Firebase.database().ref('/clients/'+global.uid+'/'+global.spaceClient+'/credits/'+c11.id).update({
        sessionsPaid: c11.paid
      })
    }
    this.props.history.push('/'+global.uid+'/admin/payments')
  }



  // Card overlay ------------------------------------------------------------



  showOverlayConfirm() {
    this.setState({
      showOverlay: true,
    })
    setTimeout(() => {
      const height = this.divElement.clientHeight
      this.setState({
        hidden: '',
        margin: -height/2,
      });
    }, 100);
  }


  hideOverlayConfirm() {
    const height = this.divElement.clientHeight
    this.setState({
      hidden: 'hidden',
      margin: -height/2+100
    })
    setTimeout(() => {
      this.setState({showOverlay: false});
    }, 500);
  }


  renderOverlayConfirm() {
    if(this.state.showOverlay) {
      return (
        <div className={'overlay '+this.state.hidden}>
          <div className="box auto" ref={ (divElement) => { this.divElement = divElement }} style={{marginTop: this.state.margin}}>
            <h2 className="mb-20 lft">{lang.t('modal:confirmpay.title')}</h2>
            <button className="btn tertiary small close rgt" onClick={() => this.hideOverlayConfirm()}>{lang.t('modal:common.close')}</button>
            <p className="clear mb-30">Are you sure you want to make a payment of {HelperBilling.showAmount(this.state.item.data.price)} and pay Invoice {this.state.item.data.number}?</p>
            <button className="btn primary" onClick={() => this.makePayment()}>{lang.t('modal:confirmpay.button')}</button>
          </div>
        </div>
      )
    }
  }



  // Modals ------------------------------------------------------------



  hideModals() {
    this.setState({
      showModalStock: false,
    })
  }


  modalClick(item) {
    this.hideModals()
    var card = false
    if(item.data.cardId === '' || item.data.cardId === undefined) {
      card = true
    }
    this.setState({
      client: item,
      card: card
    })
    if(item.data.uid !== '') {
      Connector.getClientToken(item.data.uid)
    }
  }



  // Display stuff ------------------------------------------------------------



  renderBottom() {
    if(this.state.client !== null) {
      if(this.state.card) {
        return (
          <div className="mt-20">
              <FormCard values={this.state.valuesCard} error={this.state.errorCard} onChange={(event) => this.setState({valuesCard: event})}/>
              <div className="sv-40 clear"></div>
              <button className="btn primary mb-10" onClick={() => this.checkMakePayment()}>{lang.t('admin:button.paywithcard')}</button>
          </div>
        )
      } else {
        return (
          <div>
            <div className="paymethod mt-10 mb-30">
              <WidgetCard id={this.state.client.id}/>
            </div>
            <button className="btn tertiary add width-12" onClick={() => this.setState({card: true})}>{lang.t('admin:button.anothercard')}</button>
            <div className="sv-50"></div>
            <button className="btn primary mb-10" onClick={() => this.showOverlayConfirm()}>{lang.t('admin:button.paywithcard')}</button>
          </div>
        )
      }
    }
  }


  renderGST() {
    if(this.state.item.data.gst !== 0 && this.state.item.data.gst !== undefined) {
      return <p className="clear">GST incl.<span style={{float:'right'}}>{global.curSym}{this.state.item.data.gst.toFixed(2)}</span></p>
    }
  }


  renderProducts() {
    return (
      <div className="info">
        <label>Items</label>
        <div className="sv-10"></div>
        {this.state.products.map(item => (
          <p className="clear">{item.data.name}<span style={{float:'right'}}>{global.curSym}{item.data.price.toFixed(2)}</span></p>
        ))}
        {this.renderGST()}
        <div style={{height: 10, borderBottom: '1px solid #d1d4df'}}></div>
        <div className="sv-10"></div>
        <p className="clear">Total<span style={{float:'right'}}>{global.curSym}{this.state.item.data.price.toFixed(2)}</span></p>
      </div>
    )
  }


  renderBase() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.item !== null) {
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content form-sidebar">
              <div className="col-6 mt-20">
                <div className="box">
                  {this.renderProducts()}
                  <div className="sv-20"></div>
                  {this.renderBottom()}
                </div>
              </div>

              <div className="col-6 sidebar mt-20">
                <div className="image empty large mb-30">
                  <div className="illustration">
                    <div className="img1"></div>
                    <div className="img2"></div>
                    <div className="img3"></div>
                    <div className="img4"></div>
                    {HelperEmptyImg.renderImage('payments')}
                  </div>
                </div>
                <p className="mb-30">{lang.t('admin:pay.sidebar')}</p>
              </div>
              <div className="sv-40 clear"></div>

            </div>
            <div className="header">
              <div className="content">
                <Link to={'/'+global.uid+'/admin/payments'} className="back lft mr-10">
                  <div className="circle"></div>
                  <div className="arrow"></div>
                </Link>
                <h2>{'Pay Invoice '+this.state.item.data.number}</h2>
              </div>
            </div>

            <Navigation active='billing' />
            {this.renderOverlayConfirm()}
            <ModalMessageSimple type='nostock2' show={this.state.showModalStock} onHide={() => this.hideModals()} clickMainButton={() => this.hideModals()}/>
            <Loader show={this.state.loading}/>
          </div>
        )
      } else {
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content form-sidebar">
              <div className="col-6 mt-20">
                <div className="box"></div>
              </div>

              <div className="col-6 sidebar mt-20">
                <div className="image empty large mb-30">
                  <div className="illustration">
                    <div className="img1"></div>
                    <div className="img2"></div>
                    <div className="img3"></div>
                    <div className="img4"></div>
                    {HelperEmptyImg.renderImage('payments')}
                  </div>
                </div>
                <p className="mb-30">{lang.t('admin:pay.sidebar')}</p>
              </div>
              <div className="sv-40 clear"></div>
            </div>

            <div className="header">
              <div className="content">
                <Link to={'/'+global.uid+'/admin/payments'} className="back lft mr-10">
                  <div className="circle"></div>
                  <div className="arrow"></div>
                </Link>
                <h2>{lang.t('admin:pay.invoice')}</h2>
              </div>
            </div>
            <Navigation active='billing' />
          </div>
        )
      }
    } else {
      return (
        <div className={'theme-'+global.spaceTheme}>
          <div className="content">
            <ListEmpty id='payment-locked' type='simple'/>
          </div>
          <div className="header">
            <div className="content">
              <Link to={'/'+global.uid+'/admin/payments'} className="back lft mr-10">
                <div className="circle"></div>
                <div className="arrow"></div>
              </Link>
              <h2>{lang.t('admin:pay.invoice')}</h2>
            </div>
          </div>
          <Navigation active='billing' />
        </div>
      )
    }
    
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['billing','common','header','messaging'])(withRouter(withAuthorization(condition)(PayInvoicePage)));